export enum FixtureTableColumns {
  FixtureId = "fixtureId",
  ExternalId = "externalId",
  RoundNumber = "roundNumber",
  HomeCompetitor = "homeCompetitor",
  Result = "result",
  AwayCompetitor = "awayCompetitor",
  FixtureNumber = "fixtureNumber",
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  VenueId = "venueId",
  StartDate = "startDate",
  StartTime = "startTime",
  FixtureType = "fixtureType",
  Status = "status",
  Stage = "stage",
  StageCode = "stageCode",
  Pool = "pool",
  PoolCode = "poolCode",
  Series = "series",
  SeriesCode = "seriesCode",
  Added = "added",
  Attendance = "attendance",
  Discipline = "discipline",
  StartTimeActualUtc = "startTimeActualUtc",
  EndTimeActualUtc = "endTimeActualUtc",
  FixtureProfile = "fixtureProfile",
  ProfileId = "profileId",
  InternationalReference = "internationalReference",
  Round = "round",
  RoundCode = "roundCode",
  SeriesFixtureNumber = "seriesFixtureNumber",
  TimesUnconfirmed = "timesUnconfirmed",
  StartTimeUtc = "startTimeUtc",
  HomeParticipants = "homeParticipants",
  AwayParticipants = "awayParticipants",
}
